"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandField_1 = __importDefault(require("../GraphandField"));
class GraphandFieldRelation extends GraphandField_1.default {
    constructor(data) {
        super(data);
        if (data._model && !data.ref) {
            this.ref = data._model.scope;
        }
        else if (!data.ref) {
            throw new Error(`Invalid ref ${data.ref} for field`);
        }
    }
    getter(value, from) {
        if (!value) {
            return;
        }
        let model = this._model;
        if (!model) {
            if (!from) {
                console.error(`Unable to get model from field with value ${value}`, this);
                return null;
            }
            const { constructor } = Object.getPrototypeOf(from);
            const { _client } = constructor;
            model = _client.getModel(this.ref);
        }
        if (this.multiple) {
            const ids = typeof value === "string" ? [value] : value.filter(Boolean).map((v) => v._id || v) || [];
            return model.getList({ ids });
        }
        else {
            const id = typeof value === "string" ? value : value._id;
            return model.get(id);
        }
    }
    setter(value) {
        var _a;
        if (!value) {
            return value;
        }
        if (this.multiple) {
            return ((_a = value === null || value === void 0 ? void 0 : value._ids) === null || _a === void 0 ? void 0 : _a.map((v) => v._id || v)) || (value === null || value === void 0 ? void 0 : value.filter(Boolean).map((v) => v._id || v)) || value;
        }
        else {
            return (value === null || value === void 0 ? void 0 : value._id) || value;
        }
    }
}
GraphandFieldRelation.__fieldType = "Relation";
exports.default = GraphandFieldRelation;
